import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import DeviceForm from 'Services/ServiceProviderManagement/Features/Device/Components/DeviceForm'
import { useSingleDevice } from 'Services/ServiceProviderManagement/Features/Device/Hooks'
import { SELECTED_DEVICE_PARAMETER_KEY } from 'Services/ServiceProviderManagement/Features/Device/Hooks/useDevicesWithParams'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function DeviceEditPage() {
  const baseUrl = `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/devices`

  const { id } = useParams()
  const previousLocation = usePreviousLocation(`${baseUrl}?${SELECTED_DEVICE_PARAMETER_KEY}=${id}`)
  const { singleDevice, singleLoading, submitLoading } = useSingleDevice(id)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SERVICE_PROVIDER_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Devices`,
      link: baseUrl
    },
    {
      title: singleDevice ? singleDevice.name : ''
    }
  ]

  const isLoading = singleLoading === 'pending'

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit device`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        {singleDevice && (
          <DeviceForm
            device={singleDevice}
            successBaseUrl={previousLocation}
            submitLoading={submitLoading}
          />
        )}
      </WithLoader>
    </Box>
  )
}
